import React from 'react';
import { CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { formatDateToDisplay } from '../../utils';
import { formatDuration } from '../../utils/DateUtils';
import PlayListThumbnail from '../../components/PlayListThumbnail';

const ArtistDetailsReports = (props) => {
  const { songs, isLoading } = props;
  return (
    <div style={{ display: 'flex', height: '100%', overflow: 'hidden', flex: 1, width: '100%' }}>
      <TableContainer className="tbl_wraper tbl_wrap" component={Paper}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell className="table_font result-with-image">Result</TableCell>
              <TableCell>Song Name</TableCell>
              <TableCell>Artist</TableCell>
              <TableCell style={{ minWidth: 168 }}>Date Added</TableCell>
              <TableCell style={{ minWidth: 168 }}>Duration</TableCell>
              <TableCell>Total Views</TableCell>
              <TableCell>Likes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading && (
              <div className="table_initial_loader">
                <CircularProgress />
              </div>
            )}

            {songs?.length === 0 && !isLoading ? (
              <div className="table_initial_loader">
                <h4
                  style={{
                    textAlign: 'center',
                    marginBottom: 20,
                    fontSize: 20,
                    lineHeight: '32px',
                    maxWidth: '60%',
                    marginInline: 'auto',
                  }}
                >
                  No Report Found
                </h4>
              </div>
            ) : (
              songs?.map((user, index) => (
                <TableRow key={user.id} style={{ cursor: 'pointer' }}>
                  {/* <TableCell className="result-with-image">{`#${index + 1}`}</TableCell> */}
                  <TableCell width={240} className="result-with-image">
                    <div style={{ display: 'flex', columnGap: 30, alignItems: 'center' }}>
                      <span>#{index + 1}</span>
                      <PlayListThumbnail src={user.thumbnail_img} name={user.title} style={{ borderRadius: 6 }} />
                    </div>
                  </TableCell>
                  <TableCell>{user.title}</TableCell>
                  <TableCell>{user.artist_name}</TableCell>
                  <TableCell style={{ minWidth: 168 }}>{formatDateToDisplay(user.created_at)}</TableCell>
                  <TableCell style={{ minWidth: 168 }}>{formatDuration(user.duration)}</TableCell>
                  <TableCell>{user.total_views}</TableCell>
                  <TableCell>{user.total_likes}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default ArtistDetailsReports;

